import { PaginationModel } from './util.models';

export enum transaction_status {
    complete = 'COMPLETE',
    incomplete = 'INCOMPLETE',
    refund_in_progress = 'REFUND IN PROGRESS',
    refunded = 'REFUNDED',
    refund_reject = 'REFUND REJECTED'
}

export class FilterQuery extends PaginationModel {
    consultation_type_id: number;
    from_date: Date;
    to_date: Date;
    status: transaction_status;
}

export class PatientFilterQuery extends FilterQuery {
    country_id: number;
    first: number;
}

export class DoctorFilterQuery extends PatientFilterQuery {
    specialty_id: number;
    user_guid?: string;
}

export class DoctorCsvDownload extends FilterQuery {
    country_id: number;
    specialty_id: number;
    user_guid?: string;
}
